document.addEventListener("DOMContentLoaded", function () {
  const texts = document.querySelectorAll(".akub-social-proof-text");
  let currentIndex = 0;
  let animating = false;
  const container = document.querySelector(".akub-social-proof-container");
  container.style.height = "40px";

  function showText(index) {
    if (animating || index === currentIndex) return;
    animating = true;

    const currentText = texts[currentIndex];
    const newText = texts[index];

    if (index === 1) {
      container.style.backgroundColor = "#fff";
    } else {
      container.style.backgroundColor = "#fff";
    }

    currentText.classList.add("fade-out");

    setTimeout(() => {
      currentText.hidden = true;
      currentText.classList.remove("fade-out");
      newText.classList.add("fade-in");
      newText.hidden = false;

      setTimeout(() => {
        newText.classList.remove("fade-in");
        currentIndex = index;
        animating = false;
      }, 500);
    }, 500);
  }
  showText(0);

  setInterval(() => {
    const newIndex = (currentIndex + 1) % texts.length;
    showText(newIndex);
  }, 7000);

  document
    .getElementById("akub-next-button-sp")
    .addEventListener("click", () => {
      const newIndex = (currentIndex + 1) % texts.length;
      showText(newIndex);
    });
  document
    .getElementById("akub-prev-button-sp")
    .addEventListener("click", () => {
      const newIndex = (currentIndex - 1 + texts.length) % texts.length;
      showText(newIndex);
    });
});
